import styled from '@emotion/styled';

import COLOR from '../../../constant/colorset';

import { isPC } from '../../../../../util/window/getDevice';

const Container = styled.div<{ backgroundColor: string; opacity: number; }>`
  position: absolute;
  left: 0;
  top: 0;
  opacity: ${({ opacity }) => opacity};
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const Text = styled.span<{ fontWeight: string; }>`
  font-size: ${isPC ? '14px' : '12px'};
  line-height: 1.43px;
  font-weight: ${({ fontWeight }) => fontWeight};
  color: ${COLOR.kurlyWhite};
`;

interface Props {
  backgroundColor: string;
  opacity: number;
  contents: {
    text: string;
    weight: string;
  }[];
  className?: string;
}

export default function ProductCardSticker({
  backgroundColor, opacity, contents, className,
}: Props) {
  return (
    <Container
      className={className}
      backgroundColor={backgroundColor}
      opacity={opacity / 100}
    >
      {contents.map(({ text, weight }) => (
        <Text
          key={text}
          fontWeight={weight}>
          {text}
        </Text>),
      )}
    </Container>
  );
}
